import { ISendSumPaymentUpdateData } from '@/api/mainPage/payment-order/create-sum/interface';
import DateOperations from '@/mixins/date/date-operations';
import { Component, Mixins } from 'vue-property-decorator';
import { PaymentRequirementsItem } from '../../../api/incoming/payment-requirements-incoming.interface';

@Component
export default class PaymentRequirementsMapToUZSPayment extends Mixins(
	DateOperations
) {

	mapPaymentRequirementsToUZSPayment(
		paymentRequirements: PaymentRequirementsItem
	): Partial<ISendSumPaymentUpdateData> {
		return {
			"paymentOrderId": -1,
			"id": -1,
			"cardNum": "",
			"transitAccount": "",
			"createdAt": "",
			"personalAccount": "",
			"cardType": "",
			"status": "draft",
			"paymentType": "PAYMENT",
			"operDay": this.getISODateByFormatted(
				paymentRequirements.documentDate || ''
			),
			"documentNumber": paymentRequirements.documentNumber || '',
			"srcMfo": paymentRequirements.debitMfo || '',
			"srcAccountNumber": paymentRequirements.debitAccountNumber || '',
			"srcName": paymentRequirements.debitName || '',
			"destAccountNumber": paymentRequirements.requesterAccountNumber || '',
			"destMfo": paymentRequirements.requesterMfo || '',
			"destinationName": paymentRequirements.requesterName || '',
			"knp": paymentRequirements.purposeCode || '',
			"recipientInn": paymentRequirements.requesterInn || '',
			"paymentAmount": paymentRequirements.amount || 0,
			"details": paymentRequirements.purpose || '',
		};
	}

}